import { create } from 'zustand';
import {
  getMwc,
  createMwc,
  updateMwc,
  deleteMwc,
  getRanting,
  createRanting,
  updateRanting,
  deleteRanting,
} from '../services/adminService';

const useUnitStore = create((set, get) => ({
  mwcUnits: [],
  rantingUnits: [],
  loading: false,
  error: null,

  // MWC Actions
  fetchMwc: async () => {
    set({ loading: true, error: null });
    try {
      const data = await getMwc();
      set({ mwcUnits: data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
  addMwc: async (mwcData) => {
    await createMwc(mwcData);
    get().fetchMwc();
  },
  updateMwc: async (id, mwcData) => {
    await updateMwc(id, mwcData);
    get().fetchMwc();
  },
  removeMwc: async (id) => {
    await deleteMwc(id);
    set((state) => ({ mwcUnits: state.mwcUnits.filter((u) => u.id !== id) }));
  },

  // Ranting Actions
  fetchRanting: async () => {
    set({ loading: true, error: null });
    try {
      const data = await getRanting();
      set({ rantingUnits: data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
  addRanting: async (rantingData) => {
    await createRanting(rantingData);
    get().fetchRanting();
  },
  updateRanting: async (id, rantingData) => {
    await updateRanting(id, rantingData);
    get().fetchRanting();
  },
  removeRanting: async (id) => {
    await deleteRanting(id);
    set((state) => ({ rantingUnits: state.rantingUnits.filter((r) => r.id !== id) }));
  },
}));

export default useUnitStore;
